import React from "react";
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { VeriHeading } from "../../VeriHeading";
import { JobLicenseItemProps } from "./PrincipalOverview.types";

export const JobLicenseItem: React.FC<JobLicenseItemProps> = ({
  icon,
  title,
  subtitle,
  date,
  ...rest
}) => {
  return (
    <Box mt="24px" {...rest}>
      <Flex alignItems="center">
        <Flex
          mr="16px"
          alignItems="center"
          justifyContent="center"
          height="72px"
          width="72px"
          backgroundColor="bg.greyLighter"
          borderRadius={4}
          boxShadow="inset 0px 0px 8px rgba(0, 0, 0, 0.06)"
        >
          <Icon as={icon} color="icons.grey" boxSize="24px" />
        </Flex>
        <Box>
          <VeriHeading textStyle="bodyRegularBold">{title}</VeriHeading>

          <Text mt={"4px"} textStyle="bodyRegular">
            {subtitle}
          </Text>
          <Text mt={"4px"} textStyle="bodyRegular" color="text.grey">
            {date}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
